"use client";

import { useUser } from "@clerk/nextjs";
import { useEffect, useRef } from "react";

const POSTHOG_READY_EVENT = "flare-posthog-ready";

export default function PostHogIdentify() {
  const { isLoaded, isSignedIn, user } = useUser();
  const lastIdentifiedRef = useRef(null);

  useEffect(() => {
    if (!isLoaded) return;

    const syncIdentity = () => {
      try {
        const posthog = window.__flarePosthog;
        if (!posthog) return;

        if (isSignedIn && user) {
          const distinctId = user.externalId;
          if (!distinctId) {
            if (process.env.NODE_ENV === "development") {
              // eslint-disable-next-line no-console
              console.warn("[PostHog] Skipping identify: Clerk user has no externalId yet.");
            }
            return;
          }

          if (lastIdentifiedRef.current === distinctId) return;

          const email = user.primaryEmailAddress?.emailAddress || undefined;
          const displayName =
            user.fullName ||
            [user.firstName, user.lastName].filter(Boolean).join(" ").trim() ||
            undefined;

          posthog.identify(distinctId, {
            ...(email ? { email } : {}),
            ...(displayName ? { displayName } : {}),
          });
          lastIdentifiedRef.current = distinctId;
        } else if (isSignedIn === false && lastIdentifiedRef.current) {
          if (typeof posthog.reset === "function") {
            posthog.reset();
          }
          lastIdentifiedRef.current = null;
        }
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error("[PostHog] identify/reset error:", err);
      }
    };

    syncIdentity();
    window.addEventListener(POSTHOG_READY_EVENT, syncIdentity);
    window.addEventListener("flare-cookie-consent", syncIdentity);

    return () => {
      window.removeEventListener(POSTHOG_READY_EVENT, syncIdentity);
      window.removeEventListener("flare-cookie-consent", syncIdentity);
    };
  }, [isLoaded, isSignedIn, user]);

  return null;
}
